import { PureComponent, ReactNode } from "react";
import RatingEstimatesFormStates, { RatingEstimatesFormProps } from "./RatingEstimatesForm.models";
import './RatingEstimatesForm.scss';
import formImage from '../../../assest/images/exam/takhminRotbeForm3.png';
import SelectInput from "../../shared/select/SelectInput";
import './RatingEstimatesForm.scss';
import { NavLink } from "react-router-dom";

export default class RatingEstimatesForm extends PureComponent<RatingEstimatesFormProps, RatingEstimatesFormStates>{
    constructor(props: any) {
        super(props);
        this.state = { years: [{ title: "سال 1400", value: 100 }], groups: [{ title: "ریاضی", value: 0 },{ title: "تجربی", value: 1 },{ title: "انسانی", value: 2 }] };

    }

    render(): ReactNode {
        let { groups, years } = this.state;
        let { config } = this.props;
        return <>
            <div className="rating-estimates-form-area dropdown-list mt-2">
                <div className="tk-card">
                    <div className="col-12">
                        <div className="icon">
                            <img src={formImage} width="64" height="64" alt="request exam" />
                        </div>
                        <div className="title">
                            <label>اطلاعات تحصیلی</label>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="tk-boby">
                            <div className="bd-title">
                                <label>گروه آزمایشی و سال کنکور خود را انتخاب کنید</label>
                            </div>
                            <div className="exam-content">
                                <div className="tk-padding-bottom">
                                    <label htmlFor="studentBase">گروه آزمایشی:</label>
                                    <SelectInput inputvalue={config.departementGroup} datas={groups} value={config.onChangeGroup} isNullAble={false} name='groups' />
                                </div>
                                <div className="tk-padding-bottom">
                                    <label htmlFor="course">سال کنکور:</label>
                                    <SelectInput inputvalue={config.year} datas={years} value={config.onChangeYear} isNullAble={false} name='years' />
                                </div>

                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 notspace">
                                            <button onClick={config.onChangeStep} style={{ width: "100%" }} type="submit" className="btn btn-primary">
                                                ادامه
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>;
    }
}